import { FormattedNotificationItemType, INotificationFormatter } from '@/lib/formatter/notification-formatter'
import { NotificationType } from '@/types/notification'

/**
 * PRODUCTS_EXCEL_EXPORT notification formatter
 * Extends notification with a link to the export detail page
 */
export default class ProductsExcelExportFormatter implements INotificationFormatter {
  format(notification: NotificationType): FormattedNotificationItemType {
    const id = notification.payload?.id

    const additionalParams: Array<{
      key: string
      values?: Record<string, any>
    }> = [
      {
        key: 'total_processed_products',
        values: { count: notification.payload?.total }
      }
    ]

    if (notification.payload?.message) {
      additionalParams.push({
        key: notification.payload?.message
      })
    }

    return {
      ...notification,
      additionalParams,
      link: id ? `/products/export/excel/${id}` : undefined
    }
  }
}
